import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map, Observable } from 'rxjs';
import { Result } from '@/reservation/reservation.model';
import { Transport, TransportKind } from '@/new-transport/_models/transport.model';

@Injectable({
	providedIn: 'root',
})
export class TransportTemplateApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.apiUrl;

	getTemplates(): Observable<Transport[]> {
		return this.httpClient
			.get<Result<Transport>>(`${this.apiUrl}/transport/?kind=${TransportKind.TEMPLATE}&limit=100`)
			.pipe(map((result) => result?.results));
	}

	createTransportTemplateDuplicate(transportId: number, transportData: { name: string }): Observable<{ id: number }> {
		return this.httpClient.post<{ id: number }>(
			`${environment.apiUrl}/transport/${transportId}/copy_template/`,
			transportData,
		);
	}
}
